import { render, staticRenderFns } from "./SlidBar.vue?vue&type=template&id=1398413e&scoped=true"
import script from "./SlidBar.vue?vue&type=script&lang=js"
export * from "./SlidBar.vue?vue&type=script&lang=js"
import style0 from "./SlidBar.vue?vue&type=style&index=0&id=1398413e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1398413e",
  null
  
)

export default component.exports